import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycWhatAreTheCommonMistakesMadeWhenSettingUpASpecialNeedsSupplementalNeedsTrustPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-what-are-the-common-mistakes-made-when-setting-up-a-special-needs-supplemental-needs-trust/']} />;
}
